import {
  Box,
  Button,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  DrawerProps,
  Text,
  useToast,
  VStack,
} from "@chakra-ui/react";
import { useState } from "react";
import { SelectOption } from "../../constants/SelectOption";
import { useBgHover, useRedSoftPrimary } from "../../themes/colors";
import { ButtonPrimary } from "../button/ButtonPrimary";
import { CardSkeleton } from "../skeleton/CardSkeleton";

interface Props extends DrawerProps {
  isOpen: boolean;
  onOpen: () => void;
  onClose: () => void;
  loaded?: boolean;
  title?: string;
  placement?: "bottom" | "top" | "left" | "right";
  size?: string;
  data: SelectOption[] | undefined;
  onSelectedList: (select: SelectOption | undefined) => void;
}
export const DrawerList = ({
  isOpen,
  onOpen,
  onClose,
  loaded,
  title = "List Data",
  data,
  onSelectedList,
  placement = "bottom",
  size,
  ...rest
}: Props) => {
  const [selected, setSelected] = useState<SelectOption | undefined>(undefined);
  const bgHover = useBgHover();
  const toast = useToast();
  const redPrimary = useRedSoftPrimary();

  const handleSelect = (value: any) => {
    value.id === selected?.id ? setSelected(undefined) : setSelected(value);
  };

  const handleSubmit = () => {
    if (selected) {
      onSelectedList(selected);
      onClose();
    } else {
      toast({
        title: "Pilih data terlebih dahulu",
        status: "error",
        duration: 2000,
        isClosable: true,
      });
    }
  };

  return (
    <Drawer
      isOpen={isOpen}
      onClose={onClose}
      placement={placement}
      size={size}
      {...rest}
    >
      <DrawerOverlay />
      <DrawerContent>
        <DrawerCloseButton />
        <DrawerHeader>{title}</DrawerHeader>

        <DrawerBody>
          <VStack w={"100%"}>
            {!loaded ? (
              <CardSkeleton row={1} column={5} height={40} />
            ) : (
              data &&
              data.map((item: any) => (
                <Box
                  key={item.id}
                  as="button"
                  w={"100%"}
                  px={[2, null, 3]}
                  py={[1, null, 2]}
                  fontSize={[14, null, 16]}
                  textAlign={"start"}
                  borderRadius={"md"}
                  borderWidth={"1px"}
                  onClick={() => handleSelect(item)}
                  bg={
                    selected && selected.id === item.id ? redPrimary : undefined
                  }
                  borderColor={
                    selected && selected.id === item.id ? "red.400" : undefined
                  }
                  _hover={{
                    bg:
                      selected && selected.id === item.id
                        ? redPrimary
                        : bgHover,
                  }}
                >
                  <Text textStyle={"b-reg"}>{item.name}</Text>
                </Box>
              ))
            )}
          </VStack>
        </DrawerBody>

        <DrawerFooter>
          <Button variant={"ghost"} size={["xs", null, "sm"]} onClick={onClose}>
            Tutup
          </Button>

          <ButtonPrimary
            colorScheme="red"
            size={["xs", null, "sm"]}
            onClick={handleSubmit}
          >
            Terapkan
          </ButtonPrimary>
        </DrawerFooter>
      </DrawerContent>
    </Drawer>
  );
};
